import React from 'react';
import AbstractProductBox from './AbstractProductBox';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Config from '../../../Library/Config';

interface Props {
  onPress: () => void;
  isMonthly: boolean;
  showBuyButton: boolean;
  headerClass?: string;
}

/**
 * ProductBoxUnlimited()
 * @param props
 * @constructor
 */
export default function ProductBoxUnlimited(props: Props) {
  const { isMonthly, showBuyButton, headerClass } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [priceId, setPriceId] = React.useState<string>('');

  React.useEffect(() => {
    if (isMonthly) {
      setPriceId(Config.stripe.pricePoints.unlimited.monthly);
    } else {
      setPriceId(Config.stripe.pricePoints.unlimited.yearly);
    }
  }, [isMonthly]);

  return (
    <AbstractProductBox
      headerClass={headerClass}
      showBuyButton={showBuyButton}
      caption={'Unlimited'}
      priceString={t('xPricePerMonth', { price: isMonthly ? '199,90€' : '159,90€' })}
      rebateString={
        !isMonthly ? (
          <div className={'line-through text-gray-400'}>{t('xPricePerMonth', { price: '199,90€' })}</div>
        ) : (
          <>&nbsp;</>
        )
      }
      yearlyFull={
        !isMonthly ? <div className={'text-gray-400 text-sm'}>{t('xYearlyPrice', { price: '1919,00€' })}*</div> : null
      }
      onPress={() => navigate(`/checkout/${priceId}`)}
      isMonthly={isMonthly}
      buttonColor={'cancel'}
    >
      <div className={'text-gray-500'}>
        <div className={'my-2'}>{t('subscription.unlimited.option1')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option2')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option3')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option4')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option5')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option6')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option7')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option8')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option9')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option10')}</div>
        <div className={'my-2'}>{t('subscription.unlimited.option11')}</div>
      </div>
    </AbstractProductBox>
  );
}
